import { Divider, Grid, TextField } from "@mui/material";

import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chatbotIntegration/chatbotIntegrationPopup.module.scss";
import ConfigurationSection from "../configurationPopup/ConfigurationSection";
import ChipTextField from "../../../utility/chipTextField/ChipTextField";
import { instagramCommentTriggerPayload } from "../../../../models/axiosModel";

interface InstagramAutomationTabDataProps {
    automationData: instagramCommentTriggerPayload | null;
    setAutomationData: (data: instagramCommentTriggerPayload | null) => void;
}

const InstagramAutomationTabData = (props: InstagramAutomationTabDataProps) => {
    const { automationData, setAutomationData } = props;

    // Functions
    const handleTriggerKeywordChange = (values: string[]) => {
        setAutomationData({
            ...automationData, 
            condition_group: {
                ...automationData?.condition_group, 
                condition_values: values
            }
        } as instagramCommentTriggerPayload);
    }

    const handleCommentReplyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAutomationData({
            ...automationData, 
            comment_reply: event.target.value
        } as instagramCommentTriggerPayload);
    }

    return (
        <Grid container direction="column" gap={2}>
            <ConfigurationSection
                isSectionRequired
                title="AI Chatbot Trigger Words"
                description="Add the keywords that will trigger an automatic reply. Keywords are case-insensitive, so 'hello', 'Hello', and 'HELLO' will all trigger the same response."
            >
                <ChipTextField
                    value={automationData?.condition_group?.condition_values ?? []}
                    onChange={handleTriggerKeywordChange}
                    placeholder="Type a keyword and press Enter"
                />
            </ConfigurationSection>

            <Divider />

            <ConfigurationSection
                title="Comment Reply"
                description="Set the default reply that the chatbot will send when a trigger comment is detected."
            >
                <TextField
                    fullWidth
                    multiline
                    maxRows={4}
                    placeholder="Enter the default reply"
                    value={automationData?.comment_reply ?? ""}
                    onChange={handleCommentReplyChange}
                    className={styles.configurationTextField}
                />
            </ConfigurationSection>
        </Grid>
    );
};

export default InstagramAutomationTabData;